import React, { Fragment } from 'react';
import { BreadcrumbComponent, BackLink, Item, ItemActive } from './mixins';
export var Breadcrumb = function Breadcrumb(props) {
  var _props$links = props.links,
      links = _props$links === void 0 ? [] : _props$links,
      currentTitle = props.currentTitle,
      onBackLinkClick = props.onBackLinkClick;
  return React.createElement(BreadcrumbComponent, Object.assign({}, props), onBackLinkClick && React.createElement(BackLink, {
    onClick: onBackLinkClick
  }, "Volver"), links.map(function (_ref, index) {
    var title = _ref.title,
        link = _ref.link;
    var isNotLastItem = index < links.length - 1;
    var showCaret = isNotLastItem || currentTitle;
    return React.createElement(Fragment, {
      key: title
    }, showCaret && React.createElement(Item, {
      href: link,
      icon: {
        name: 'icon-light-caret-right',
        position: 'right',
        color: 'primary'
      },
      linkoptions: {
        native: false,
        size: 'small',
        type: 'link',
        variant: 'primary'
      }
    }, title), !showCaret && React.createElement(ItemActive, {
      disabled: true,
      linkoptions: {
        native: false,
        size: 'small',
        type: 'link',
        variant: 'black'
      }
    }, title));
  }), currentTitle && React.createElement(ItemActive, null, currentTitle));
};